import { AbstractControl, ValidationErrors } from '@angular/forms';

export function singleEmailValidator(
  control: AbstractControl<string | null>
): ValidationErrors | null {
  if (!control.value) {
    return null;
  }

  const value = control.value.trim();

  if (/[;,]\s*$/.test(value)) {
    return { singleEmail: true };
  }

  if (value.includes(',') || value.includes(';')) {
    return { singleEmail: true };
  }

  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  if (!emailRegex.test(value)) {
    return { singleEmail: true };
  }

  return null;
}
